import React, { useState } from "react";
import { Slider, ConfigProvider } from "antd";
import "antd/dist/reset.css";
import "./times-fliter.scss";


function formatHour(hour) {
  return hour.toString().padStart(2, "0") + ":00";
}

function RangeCard({ title, options, range, onChange }) {
  const minHour = Math.min(...options.map(o => o.hour));
  const maxHour = Math.max(...options.map(o => o.hour));

  const [slideRange, setSlideRange] = useState(range);

  const marks = options.reduce((acc, o) => {
    acc[o.hour] = (
      <div className="hour-mark">
        <div>{formatHour(o.hour)}</div>
        <div className="price">{o.displayLowestPrice}</div>
      </div>
    );
    return acc;
  }, {});

  return (
    <div className="range-card">
      <div className="range-header">
        <span>{title}: </span>
        <strong>
          {formatHour(range[0])} - {formatHour(range[1])}
        </strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Slider: {
              dotActiveBorderColor: '#CBA135',
              handleColor: '#CBA135',
              handleActiveColor: '#CBA135',
              handleActiveOutlineColor: 'rgba(203,161,53,0.2)',
              trackBg: '#CBA135',
              trackHoverBg: '#CBA135',
              colorPrimaryBorderHover: '#CBA135'
            },
          },
        }}
        >
        <Slider
            range
            min={0}
            max={24}
            step={1}
            value={slideRange}
            // marks={marks}
            onChange={(val) => setSlideRange(val)}       
            onChangeComplete={onChange}
        />
      </ConfigProvider>
      <div className="time-labels">
        <span>00:00</span>
        <span>06:00</span>
        <span>12:00</span>
        <span>18:00</span>
        <span>24:00</span>
      </div>
    </div>
  );
}

export default function TimesFilter({ filterTags, filterDefinition, onChange }) {
  const departOptions = filterDefinition.children[0].options;
  const arriveOptions = filterDefinition.children[1].options;

  const departFilterTag = (filterTags || []).find(tag => tag.key === 'depart');
  const departRange = !!departFilterTag ? [departFilterTag.value.start, departFilterTag.value.end] : [0, 24];

  const arriveFilterTag = (filterTags || []).find(tag => tag.key === 'arrive');
  const arriveRange = !!arriveFilterTag ? [arriveFilterTag.value.start, arriveFilterTag.value.end] : [0, 24];

  return (
    <div className="wrap-box times-tab">
      <h6>
        Times <span>(Local time)</span>
      </h6>

      <RangeCard title="Depart" options={departOptions} range={departRange} onChange={(value) => onChange('depart', value)} />
      <RangeCard title="Arrive" options={arriveOptions} range={arriveRange} onChange={(value) => onChange('arrive', value)} />
    </div>
  );
}